let routeList = {
  'notifyList':[
    {name: '消息', path: false}
  ],
  'applyIndex': [
    { name: '保函申请', path: false }
  ],
  'projectListBidsecurity': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '工程投标保证保函', path: '/apply/index' },
    { name: '项目申请列表', path: false }
  ],
  'applyBidsecurity': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '工程投标保证保函', path: '/apply/index' },
    { name: '项目申请列表', path: '/projectList/bidSecurity' },
    { name: '详情', path: false }
  ],
  'applyCultural': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '旅游质量保证金保函', path: false },
  ],
  'projectListGovbidsecurity': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '政采投标保证保函', path: '/apply/index' },
    { name: '项目申请列表', path: false }
  ],
  'applyGovbidsecurity': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '政采投标保证保函', path: '/apply/index' },
    { name: '项目申请列表', path: '/projectList/govBidSecurity' },
    { name: '详情', path: false }
  ],

  'applyContract': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '工程合同履约保函', path: false },
  ],
  'applyCustoms': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '海关关税保函', path: false },
  ],
  'applyPeasant': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '农民工工资支付保函', path: false },
  ],
  'applyQuality': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '工程质量保函', path: false },
  ],
  'applyGovcontract': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '政采合同履约保函', path: false },
  ],
  'applyLawsuit': [
    { name: '法院诉讼申请', path: '/apply/index', back: true },
    {
      name: function (e) {
        if (e.query.preserveForm == 0) return '法院诉讼财产保全保函'
        if (e.query.preserveForm == 1) return '法院诉讼证据保全保函'
        if (e.query.preserveForm == 2) return '法院诉讼行为保全保函'
        if (e.query.preserveForm == 3) return '法院诉讼先予执行保函'
        if (e.query.preserveForm == 4) return '法院诉讼继续执行保函'
        if (e.query.preserveForm == 5) return '法院诉讼解封保全保函'
      }, path: false
    },
  ],
  'applyTariff': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '海关关税保函', path: false },
  ],
  "applyBidding":[
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '竞买保证金保函', path: false },
  ],
  'applyAdvance': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '工程预付款保函', path: false },
  ],
  'applyGovadvance': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '政采预付款保函', path: false },
  ],
  'applyOwner': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '业主支付保函', path: false },
  ],
  'applyTeamrisk': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '建筑工程团意险', path: false },
  ],
  'applyAllrisk': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '建筑工程一切险', path: false },
  ],

  'applyCarrisk': [
    { name: '保函申请', path: '/apply/index', back: true },
    { name: '车险', path: false },
  ],

  'orderIndex': [
    { name: '保函订单', path: false }
  ],
  'orderLawsuitList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '法院诉讼保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderGovBidsecurityList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '政采投标保证保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderGovcontractList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '政采合同履约保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderBidsecurityList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '工程投标保证保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderBiddingList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '竞买保证金保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderSafeList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '安责险', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderGovbidsecurityList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '政采投标保证保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'projectGovbidsecurityList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '政采投标保证保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderContractList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '工程合同履约保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderPeasantList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '农民工工资支付保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderQualityList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '工程质量保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderCustomsList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '海关关税保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],

  'orderAdvanceList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '工程预付款保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderOwnerList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '业主支付保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderGovadvanceList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '政采预付款保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderCulturalList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '旅游质量保证金保函', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderTeamriskList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '建筑工程团意险', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderAllriskList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '建筑工程一切险', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'orderCarriskList': [
    { name: '保函订单', path: '/order/index', back: true },
    { name: '车险', path: '/order/index' },
    { name: '订单列表', path: false },
  ],
  'loanApply': [
    { name: '贷款申请', path: false }
  ],
  'loanInstitutionlist': [
    { name: '贷款申请', path: '/loan/apply', back: true },
    { name: '选择金融机构', path: false }
  ],

  'loanOrder': [
    { name: '贷款订单', path: false }
  ],

  'billOrderList': [
    { name: '贴现订单', path: false },
    { name: '银票订单列表', path: false },
  ],
  'billOrderBusinesslist': [
    { name: '贴现订单', path: false },
    { name: '商票订单列表', path: false },
  ],
  'billOrderDetail': [
    { name: '贴现订单', path: function (e) { return e.query.type == 0 ? '/billOrder/list' : '/billOrder/businessList' }, back: true },
    {
      name: function (e) {
        return e.query.type == 0 ? '银票订单列表' : '商票订单列表'
      }, path: function (e) { return e.query.type == 0 ? '/billOrder/list' : '/billOrder/businessList' }, key: 'type'
    },
    { name: '详情', path: false },
  ],

  'invoiceList': [
    { name: '我的发票', path: false },
  ],
  'invoiceDetail': [
    { name: '我的发票', path: '/invoice/list', back: true },
    { name: '详情', path: false },
  ],

  'userAccountInfo': [
    { name: '用户中心', path: false },
    { name: '账号信息', path: false },
  ],
  'userCompanyInfo': [
    { name: '用户中心', path: false },
    { name: '企业信息', path: false },
  ],
  'userCompanyEdit': [
    { name: '用户中心', path: '/user/company/info',back:true },
    { name: '企业信息', path: '/user/company/info' },
    { name: '修改企业信息', path: false },
  ],
  'userQualificationsList': [
    { name: '用户中心', path: false },
    { name: '企业资质', path: false },
  ],
  'userQualificationsEdit': [
    { name: '用户中心', path: false ,back:true},
    { name: '企业资质', path: '/user/qualifications/list' },
    {
      name: function (e) {
        return e.query.id ? '编辑资质' : '添加资质'
      }, path: false
    },
  ],
  'userCa': [
    { name: '用户中心', path: false },
    { name: 'CA证书', path: false },
  ],
  'couponIndex': [
    { name: '优惠券中心', path: false },
  ],
  'pointsIndex': [
    { name: '积分活动', path: false },
  ],
  'pointsDetail': [
    { name: '积分活动', path: '/points/index',back:true },
    { name: '奖品详情', path: false },
  ],
  'pointsMine': [
    { name: '积分活动', path: '/points/index',back:true },
    { name: '我的积分', path: false },
  ],
  'documentsIndex': [
    { name: '文书生成', path: false },
  ],
  'documentsCivilcomplaintCasetype': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '民事起诉状', path: false },
  ],
  'documentsCivilcomplaintDescription': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '民事起诉状', path: false },
  ],
  'documentsCivilcomplaintConfirm': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '民事起诉状', path: false },
  ],
  'documentsCivilcomplaintGenerated': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '民事起诉状', path: false },
  ],
  'documentsCivilcomplaintComplete': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '民事起诉状', path: false },
  ],
  'documentsPreservationCasetype': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '保全申请书', path: false },
  ],
  'documentsPreservationDescription': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '保全申请书', path: false },
  ],
  'documentsPreservationConfirm': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '保全申请书', path: false },
  ],
  'documentsPreservationGenerated': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '保全申请书', path: false },
  ],
  'documentsPreservationComplete': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '保全申请书', path: false },
  ],
  'documentsRecordsIndex': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '文书生成记录', path: false },
  ],
  'documentsTemplatesIndex': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '模板列表', path: false },
  ],
  'documentsCivilcomplaintIndex': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '民事起诉状', path: false },
  ],
  'documentsPreservationIndex': [
    { name: '文书生成', path: '/documents/index', back: true },
    { name: '保全申请书', path: false },
  ],
}

let analysisRoute = function (route) {
  let list = routeList[route.name]
  if (!list) return []
  let result = list.map(item => {
    if (typeof item.name == "string") {
      return {
        name: item.name,
        path: typeof item.path == 'function' ? item.path(route) : item.path,
        back: item.back || false
      }
    }
    if (typeof item.name == "function") {
      return {
        name: item.name(route),
        path: typeof item.path == 'function' ? item.path(route) : item.path,
        back: item.back || false
      }
    }
  })
  return result
}
export default analysisRoute;